import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
    DashboardOutlined,
    TeamOutlined,
    CarOutlined,
    HomeOutlined,
    ScheduleOutlined
} from '@ant-design/icons';
import { KeyRound, MessageSquareMore } from 'lucide-react';
import LucideNavIcon from 'components/Resi/ui/LucideNavIcon';
import { ResiPermissions } from 'permissions/resi-permissions';
import { RESI_ROUTER_NAMESPACE } from 'utils/route-guard/ResiGuard';

const icons = {
    DashboardOutlined,
    TeamOutlined,
    CarOutlined,
    HomeOutlined,
    ScheduleOutlined,
    KeyRound: props => <LucideNavIcon icon={KeyRound} {...props} />,
    MessageSquareMore: props => <LucideNavIcon icon={MessageSquareMore} {...props} />
};

export const resiDashboard = {
    id: 'resi_dashboard',
    title: null,
    type: 'group',
    children: [
        {
            id: 'guests',
            title: <FormattedMessage id="guests" />,
            type: 'item',
            url: `${RESI_ROUTER_NAMESPACE}/guests`,
            icon: icons.TeamOutlined,
            requiredPermission: ResiPermissions.VIEW_GUESTS
        },
        // {
        //     id: 'dashboard',
        //     title: <FormattedMessage id="dashboard" />,
        //     type: 'item',
        //     url: '/dashboard',
        //     icon: icons.DashboardOutlined,
        //     // requiredPermission: ResiPermissions.VIEW_DASHBOARD
        // },
        {
            id: 'resi-main-divider',
            type: 'divider'
        },

        {
            id: 'access-keys',
            title: <FormattedMessage id="access-keys" />,
            type: 'item',
            url: `${RESI_ROUTER_NAMESPACE}/access-keys`,
            icon: icons.KeyRound,
            // requiredPermission: ResiPermissions.MANAGE_ACCESS_KEY
        },
        {
            id: 'vehicles',
            title: <FormattedMessage id="vehicles" />,
            type: 'item',
            url: `${RESI_ROUTER_NAMESPACE}/vehicles`,
            icon: icons.CarOutlined,
            requiredPermission: ResiPermissions.VIEW_VEHICLES
        },
        {
            id: 'occupants',
            title: <FormattedMessage id="occupants" />,
            type: 'item',
            url: `${RESI_ROUTER_NAMESPACE}/occupants`,
            icon: icons.HomeOutlined,
            requiredPermission: ResiPermissions.VIEW_OCCUPANTS
        },
        {
            id: 'resi-rentals',
            title: <FormattedMessage id="rentals table" />,
            type: 'item',
            url: `${RESI_ROUTER_NAMESPACE}/resi-rentals`,
            icon: icons.ScheduleOutlined,
            requiredPermission: ResiPermissions.MANAGE_RENTALS
        }
    ]
};

export const userArea = {
    id: 'user_area',
    type: 'group',
    children: [
        {
            id: 'resi-main-divider',
            type: 'divider'
        },
        {
            id: 'support',
            title: <FormattedMessage id="support" />,
            type: 'item',
            url: `${RESI_ROUTER_NAMESPACE}/support`,
            icon: icons.MessageSquareMore
        }
    ]
};
